// @flow

const OrganizationMemberRoleConstants = {
  ADMIN: "ADMIN",
  MEMBER: "MEMBER"
};

export default OrganizationMemberRoleConstants;
